<template>
  <div class="my-account bg-grey h-100">
    <NavbarMain />
    <div class="row m-0 px-md-5 px-1 py-3 bg-grey full-container">
      <NavbarAccount class="col-xl-auto col-md-12 col-12 h-100" />
      <div class="col-xl col-md-12 px-xl-2 px-sm-0">
        <div class="row _container mx-auto">
          <div
            class="
              col-12
              d-flex
              justify-content-between
              align-items-center
              my-4
            "
          >
            <h1>
              <b class="text-blue-light">
                Compra
                <span class="text-blue-shadow">#{{ buy.prettyID }}</span>
              </b>
            </h1>
            <div>
              <span class="d-flex align-items-center h6">
                <span class="material-icons mr-2">calendar_today</span>
                {{ dateToFullString(buy.creationDate) }}
              </span>
            </div>
          </div>
          <div class="col-lg-8 px-0 px-sm-2 col-12">
            <ProductsDetail :products="buy.products" :services="buy.services" />
            <ShippingDetail
              v-if="buy.shippingType != 2"
              :shippingType="buy.shippingType"
              :shippingPrice="buy.shippingPrice"
            />
            <PaymentDetail
              :products="buy.products"
              :otherPayments="buy.otherPayments"
              :sacoin="buy.sacoin"
              :financiamiento="buy.financiamiento"
              :shippingPrice="buy.shippingPrice"
            />

            <!--  /* ESTADO DE ENVIO PRODUCTO */ v-if="buy.products.length"  -->
            <div
              class="shadow-blue-sm rounded bg-white px-3 mt-3 pt-3 mb-3"
              
            >
              <h5 class="d-flex align-items-center mb-5">
                <span class="material-icons mr-2">local_shipping</span> Estado
                del envío
              </h5>

              <div class="pb-4" v-if="buy.creationDate != ''">
                <div class="state_shipping row">
                  <div class="col-6 pt-4 text-right">
                    {{ dateToString(buy.creationDate) }}
                  </div>
                  <div class="col border-left-success">
                    <span
                      class="material-icons text-success"
                      style="position: relative; left: -31px; top: -2px"
                    >
                      lens
                    </span>
                    <h6 class="mb-4">En proceso de aceptación</h6>
                  </div>
                </div>

                <div
                  class="state_shipping row"
                  v-if="existState('CANCEL_BY_BUYER')"
                >
                  <div class="col-6 pt-4 text-right">
                    {{ dateToString(getDateState("CANCEL_BY_BUYER")) }}
                  </div>
                  <div class="col border-left-danger">
                    <span
                      class="material-icons text-danger"
                      style="position: relative; left: -31px; top: -2px"
                    >
                      lens
                    </span>
                    <h6 class="mb-4">Cancelado por el comprador</h6>
                  </div>
                </div>

                <div
                  v-if="
                    !existState('CANCEL_BY_SELLER') &&
                    !existState('CANCEL_BY_BUYER')
                  "
                >
                  <div class="state_shipping row">
                    <div class="col-6 pt-4 text-right">
                      <span v-if="existState('IN_PREPARATION')">{{
                        dateToString(getDateState("IN_PREPARATION"))
                      }}</span>
                    </div>
                    <div
                      class="col"
                      :class="
                        existState('IN_PREPARATION')
                          ? 'border-left-success'
                          : 'border-left-secondary'
                      "
                    >
                      <span
                        class="material-icons"
                        :class="
                          existState('IN_PREPARATION')
                            ? 'text-success'
                            : 'text-secondary'
                        "
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En preparación</h6>
                    </div>
                  </div>

                  <div class="state_shipping row" v-if="buy.shippingType != 2">
                    <div class="col-6 pt-4 text-right">
                      <span v-if="existState('IN_TRAVEL')">{{
                        dateToString(getDateState("IN_TRAVEL"))
                      }}</span>
                    </div>
                    <div
                      class="col"
                      :class="
                        existState('IN_TRAVEL')
                          ? 'border-left-success'
                          : 'border-left-secondary'
                      "
                    >
                      <span
                        class="material-icons"
                        :class="
                          existState('IN_TRAVEL')
                            ? 'text-success'
                            : 'text-secondary'
                        "
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En viaje</h6>
                      <span
                        >Código de seguimiento:
                        {{ getInfoState("IN_TRAVEL") }}</span
                      >
                    </div>
                  </div>

                  <div class="state_shipping row">
                    <div class="col-6 pt-4"></div>
                    <div
                      class="col"
                      :class="
                        existState('DELIVERED') || existState('PICKUP')
                          ? 'border-left-success'
                          : 'border-left-secondary'
                      "
                    >
                      <span
                        class="material-icons"
                        :class="
                          existState('IN_TRAVEL') || existState('PICKUP')
                            ? 'text-success'
                            : 'text-secondary'
                        "
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">
                        {{ existState("DELIVERED") ? "Entregado" : "Recogido" }}
                      </h6>
                    </div>
                  </div>

                  <div
                    class="col-12 text-center"
                    v-if="!existState('IN_PREPARATION')"
                  >
                    <h6>Quieres cancelar la compra?</h6>
                    <span
                      class="btn btn-danger mx-2"
                      @click="handleSetState('CANCEL_BY_BUYER')"
                      >Cancelar compra</span
                    >
                  </div>
                </div>
                <div
                  class="state_shipping row"
                  v-if="existState('CANCEL_BY_SELLER')"
                >
                  <div class="col-6 pt-4 text-right">
                    {{ dateToString(getDateState("CANCEL_BY_SELLER")) }}
                  </div>
                  <div class="col border-left-danger">
                    <span
                      class="material-icons text-danger"
                      style="position: relative; left: -31px; top: -2px"
                    >
                      lens
                    </span>
                    <h6 class="mb-4">Cancelado por el vendedor</h6>
                  </div>
                </div>
                <div
                  class="state_shipping row"
                  v-if="
                    existState('CANCEL_BY_SELLER') ||
                    existState('CANCEL_BY_BUYER')
                  "
                >
                  <div class="col-6"></div>
                  <div class="col">
                    <div style="position: relative; left: -25px; top: -2px">
                      <span class="material-icons text-danger"> lens </span>
                    </div>
                  </div>
                  <div class="col-12">
                    <h6 class="text-center">Compra cancelada</h6>
                  </div>
                </div>
                <div
                  class="state_shipping row"
                  v-if="lastState('DELIVERED') || lastState('PICKUP')"
                >
                  <div class="col-6"></div>
                  <div class="col">
                    <div style="position: relative; left: -25px; top: -2px">
                      <span class="material-icons text-success"> lens </span>
                      <h6 style="position: relative; left: -4px">Listo</h6>
                    </div>
                  </div>
                </div>
                <div v-if="lastState('IN_TRAVEL') || lastState('REMEMBER_DELIVERED')">
                  <div class="state_shipping row">
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-secondary">
                          lens
                        </span>
                      </div>
                    </div>
                    <div v-if="!buy.claim" class="col-12 text-center">
                      <h6>Ya recibiste el envío?</h6>
                      <div class="form-inline d-flex justify-content-center">
                        <span
                          class="btn btn-danger mx-2 mb-2"
                          @click="handleShowChat"
                          >Tengo un inconveniente con el producto</span
                        >
                        <span
                          class="btn btn-treid mx-2 mb-2"
                          @click="handleSetState('DELIVERED')"
                          >Si, ya recibí el producto</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="lastState('IN_PREPARATION') && buy.shippingType == 2"
                >
                  <div class="state_shipping row">
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-secondary">
                          lens
                        </span>
                      </div>
                    </div>
                    <div v-if="!buy.claim" class="col-12 text-center">
                      <h6>Ya recogiste el producto?</h6>
                      <div class="form-inline d-flex justify-content-center">
                        <span
                          class="btn btn-treid mx-2"
                          @click="handleSetState('PICKUP')"
                          >Si, ya recogí el producto</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <h6 v-if="buy.claim" class="alert alert-warning text-center">
                  Reclamo iniciado
                </h6>
              </div>
            </div>
            <!--  /* ESTADO DE ENVIO SERVICIO 
            <StateDetail v-else
              :state="buy.state"
              :isBuyer="buy.buyer._id == auth.id"
              :isSeller="buy.seller._id == auth.id"
             />
             */  -->
          </div>
          <div class="col-lg-4">
            <div class="alert alert-info"><span class="material-icons position-absolute">privacy_tip</span><span class="pl-4">si tienes una consulta, <a :href="`https://www.sistemaapple.com.mx/soporte/mis-chats?platform=TREID_BLUE&module=BUY&id=${$route.params.id}&prettyID=${buy.prettyID}`" class="font-weight-bold">click aquí</a> para más ayuda</span></div>
            <div class="shadow-blue-sm rounded bg-white p-3">
              <h5 class="d-flex align-items-center">
                <span class="material-icons mr-2">account_circle</span>Vendedor
              </h5>
              <div class="row mt-4">
                <div class="col-lg-2 mx-sm-auto">
                  <span class="material-icons" style="font-size: 50px"
                    >account_circle</span
                  >
                </div>
                <div class="col-lg-10 d-flex align-items-center">
                  <h5 class="text-capitalize ml-3 mx-sm-auto">
                    {{ buy.seller.username }}
                  </h5>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-lg-2 mx-sm-auto">
                  <span class="material-icons mr-2" style="font-size: 50px"
                    >store</span
                  >
                </div>
                <div
                  class="col-lg-10 d-flex align-items-center text-capitalize"
                >
                  <h5 class="ml-3 mx-sm-auto">{{ buy.countSells }} ventas</h5>
                </div>
              </div>
              <h5 class="d-flex align-items-center mt-5">
                <span class="material-icons mr-2">contacts</span>Contacto
              </h5>
              <h6 class="ml-md-3 ml-5">Correo: {{ buy.seller.email }}</h6>
              <h6 class="ml-md-3 ml-5">Teléfono: -</h6>
              <h6 class="ml-md-3 ml-5">Nombre: {{ buy.seller.fullName }}</h6>
              <h6 class="ml-md-3 ml-5">DNI: {{ buy.seller.dni }}</h6>
            </div>
            <div class="shadow-blue-sm rounded bg-white p-3 mt-3">
              <h5 class="d-flex align-items-center mb-4">
                <span class="material-icons mr-2">chat</span>
                conversación
              </h5>
              <div class="text-center">
                <span class="btn btn-treid btn-block" @click="handleShowChat"
                  >Ver chat</span
                >
                <span
                  v-if="this.buy.claim"
                  class="btn btn-success btn-block mt-3"
                  >Reclamo iniciado</span
                >
                <span
                  v-else
                  class="btn btn-danger btn-block mt-3"
                  @click="handleShowInitClaim"
                  >Iniciar reclamo</span
                >
              </div>
            </div>
            <div class="shadow-blue-sm rounded bg-white p-3 mt-3" v-show="buy.shippingType != 2">
              <h5 class="d-flex align-items-center mb-4">
                <span class="material-icons mr-2">flight_takeoff</span>Datos del
                envío
              </h5>
              <div
                class="px-4 py-1"
                v-for="info in buy.shippingInfo"
                :key="info.key"
              >
                <div class="">
                  <b>{{ info.key }}:</b>
                  <span class="pl-2">{{ info.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalChatSale
      v-if="buy._id"
      :visible="modalChatSale.visible"
      v-on:close="handleCloseChat()"
      :buy="buy._id"
      :claim="buy.claim"
    />
    <ModalConfirmTicket
      v-on:close="handleCloseConfirmTicket"
      v-on:accept="handleConfirmTicket"
      :visible="modalConfirmTicket.visible"
      :load="modalConfirmTicket.load"
    />
  </div>
</template>

<script>
import Configs from "@/configs/configs";
import { mapState } from "vuex";
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAccount from "@/components/account/NavbarAccount.vue";
import ModalChatSale from "@/components/modals/ModalChatSale";
import ModalConfirmTicket from "@/components/modals/ModalConfirmTicket";
import { CONSTANT_BUY } from "../../configs/contants";
import PaymentDetail from "../../components/buy/PaymentDetail.vue";
import ShippingDetail from "../../components/buy/ShippingDetail.vue";
import ProductsDetail from "../../components/buy/ProductsDetail.vue";
//import StateDetail from "../../components/buy/StateDetail.vue"
import Api from "@/tools/Api2";
export default {
  name: "MyPurchase",
  components: {
    NavbarMain,
    NavbarAccount,
    ModalChatSale,
    PaymentDetail,
    ShippingDetail,
    ProductsDetail,
    ModalConfirmTicket,
   // StateDetail
  },
  data() {
    return {
      ticketEmit: false,
      modalChatSale: {
        visible: false,
      },
      modalConfirmTicket: {
        visible: false,
        load: false,
      },
      url_base: Configs.API.BASE,
      buy: {
        buyer: { _id: "", username: "" },
        creationDate: "",
        financiamiento: 0,
        products: [],
        sacoin: 0,
        seller: { _id: "", username: "" },
        shippingInfo: [],
        shippingPrice: 0,
        state: [],
        countSells: 0,
        claim: false,
        otherPayments: [],
      },
      url: Configs.API.BASE,
    };
  },
  methods: {
    handleShowChat() {
      this.modalChatSale.visible = true;
    },
    handleCloseChat() {
      this.modalChatSale.visible = false;
    },
    handleSetState(name) {
      Api(`buy/state/${this.buy._id}`)
        .post({ name, info: "" })
        .then((res) => {
          this.buy.state = res.state;
        });
    },
    getInfoState(name) {
      let state = this.buy.state.find((x) => x.name == name);
      return state ? state.info : "";
    },
    getDateState(name) {
      let buy = this.buy.state.find((x) => x.name == name);
      return buy.date;
    },
    lastState(name) {
      return this.buy.state.length
        ? this.buy.state[this.buy.state.length - 1].name == name
        : "NO_STATE_NAME" == name;
    },
    existState(name) {
      return this.buy.state.find((x) => x.name == name);
    },
    dateToString(str) {
      let date = new Date(str);
      return `${date.getDate()}/${
        (date.getMonth() < 10 ? "0" : "") + date.getMonth()
      }/${date.getFullYear()}`;
    },
    dateToFullString(str) {
      let date = new Date(str);
      return `${date.getDate()}.${
        (date.getMonth() < 10 ? "0" : "") + date.getMonth()
      }.${date.getFullYear()} a las ${date.getHours()}:${date.getMinutes()}`;
    },
    handleCloseConfirmTicket() {
      this.modalConfirmTicket.visible = false;
    },
    handleConfirmTicket() {
      this.modalConfirmTicket.load = true;
      Api("buy/claim")
        .patch(this.buy._id, { claim: true })
        .then(() => {
          this.modalConfirmTicket.load = false;
          this.ticketEmit = true;
          this.modalConfirmTicket.visible = false;
        });
    },
    handleShowInitClaim() {
      this.modalConfirmTicket.visible = true;
    },
  },
  computed: {
    ...mapState(["auth"]),
  },
  created: async function () {
    Api("buy")
      .get(this.$route.params.id)
      .then((res) => {
        if(res.buy.buyer._id != this.auth.id){
          return this.$router.push({ name: "Home" });
        }

        res.buy.shippingTypeName =
          CONSTANT_BUY.shippingType[res.buy.shippingType];
        this.buy.countSells = res.count.sells;
        this.buy = res.buy;
      });
  },
};
</script>

<style lang="scss" scoped>
.border-left-danger {
  border-left: 6px solid #dc3545 !important;
}
.border-left-secondary {
  border-left: 6px solid #6c757d !important;
}
.border-left-success {
  border-left: 6px solid #28a745 !important;
}
.text-dark-blue {
  color: #343c6a;
}
footer {
  position: absolute;
}

.text-secondary a {
  color: #172b46 !important;
  font-weight: bold;
}

.text-blue-shadow {
  color: #1a3d6b;
  text-shadow: 0px 0px 3px rgba(26, 71, 107, 0.4);
}

.text-blue-light {
  color: #617c9c;
}

.bg-blue-light-2 {
  background-color: #f9fafc;
}

.shadow-blue-sm {
  box-shadow: 0 0.125rem 0.25rem #e8ecf3 !important;
}

@media screen and (max-width: 1024px) {
  .product {
    padding: 1em 3em 1em 0.5em;
  }
}

@media screen and (max-width: 414px) {
  .full-container {
    padding: 0.5em !important;
  }

  .mx-sm-auto {
    margin-left: auto !important;
    margin-right: auto !important;
    text-align: center !important;
  }
}

.bage-notification {
  position: relative;
  top: -12px;
  right: 16px;
}
</style>
